module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_1@2x.96c26045.png";